import { Component, Input, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { setTheme } from '../../visual/visual.actions';

@Component({
  selector: 'nns-header-theme-selector',
  template: `
    <div flex layout="row" layout-align="start center"
      title="{{visual.theme == 'day' ? 'Switch to dark theme' : 'Switch to light theme'}}">
      <nns-icon *ngIf="visual.theme == 'day'" icon="day-mode-grey"></nns-icon>
      <nns-icon *ngIf="visual.theme == 'night'" icon="night-mode-grey"></nns-icon>
    </div>
  `,
  styles: [`
    :host {
      cursor: pointer;
    }
    nns-icon{
      min-width: 16px;
      min-height: 16px;
    }
  `]
})

export class HeaderThemeSelectorComponent {
  @Input() visual;
  constructor(
    public _store: Store<IAppState>
  ) { }

  @HostListener('click', ['$event'])
  changeMode() {
    if (this.visual.theme === 'day') {
      this._store.dispatch(setTheme('night'));
    } else {
      this._store.dispatch(setTheme('day'));
    }
  }
}
